import { useNavigate } from 'react-router-dom';

function useRedirectAfterLogin() {
  const navigate = useNavigate();
  const setRedirectAfterLogin = () => {
    localStorage.setItem(
      '_REDIRECT_AFTER_LOGIN_',
      `${window.location.pathname}${window.location.search}`,
    );
  };

  const redirectAfterLogin = () => {
    const originalRoute = localStorage.getItem('_REDIRECT_AFTER_LOGIN_');
    if (originalRoute) {
      localStorage.removeItem('_REDIRECT_AFTER_LOGIN_');
      navigate(originalRoute);
    }
  };

  return {
    setRedirectAfterLogin,
    redirectAfterLogin,
  };
}

export default useRedirectAfterLogin;
